import LoaderInfo from './LoaderInfo'

export default LoaderInfo